var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStHail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_369_3875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10.8105,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#85CDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5455,
    y: 12.356,
    width: 64.9091,
    height: 64.9091,
    rx: 32.4545,
    stroke: "white",
    strokeWidth: 3.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9692 34.3106L56.1476 34.6848L56.558 34.7431C59.7284 35.1935 62.2273 38.0362 62.2273 41.5172C62.2273 45.3145 59.2711 48.3445 55.6923 48.3445H53.7436C53.3997 48.3445 53.0548 48.0302 53.0548 47.5972C53.0548 47.1642 53.3997 46.8499 53.7436 46.8499H55.6923C58.5638 46.8499 60.8497 44.4282 60.8497 41.5172C60.8497 38.6062 58.5638 36.1845 55.6923 36.1845C55.4414 36.1845 55.1859 36.0283 55.0631 35.7329C53.1966 31.0995 48.87 28.0778 44 28.0778C39.1287 28.0778 34.8012 31.1011 32.9355 35.7364L32.9324 35.7441L32.9294 35.7519C32.8302 36.0147 32.5752 36.1845 32.3077 36.1845C29.4362 36.1845 27.1503 38.6062 27.1503 41.5172C27.1503 44.4282 29.4362 46.8499 32.3077 46.8499H34.2564C34.6003 46.8499 34.9452 47.1642 34.9452 47.5972C34.9452 48.0302 34.6003 48.3445 34.2564 48.3445H32.3077C28.7289 48.3445 25.7727 45.3145 25.7727 41.5172C25.7727 38.0326 28.2743 35.1751 31.4378 34.7437L31.8512 34.6873L32.0308 34.3106C34.2861 29.5812 38.8943 26.5833 44 26.5833C49.1057 26.5833 53.7139 29.5812 55.9692 34.3106Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 1.54545
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9294 49.5798C43.1501 49.5798 44.0629 48.5639 44.0629 47.4074C44.0629 46.2508 43.1501 45.235 41.9294 45.235C40.7087 45.235 39.796 46.2508 39.796 47.4074C39.796 48.5639 40.7087 49.5798 41.9294 49.5798Z",
    stroke: "white",
    strokeWidth: 2.31818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8472 58.8897C51.606 58.8897 52.955 57.4201 52.955 55.7039C52.955 53.9877 51.606 52.5182 49.8472 52.5182C48.0883 52.5182 46.7393 53.9877 46.7393 55.7039C46.7393 57.4201 48.0883 58.8897 49.8472 58.8897Z",
    stroke: "white",
    strokeWidth: 2.31818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.103 64.9693C41.8618 64.9693 43.2108 63.4997 43.2108 61.7835C43.2108 60.0673 41.8618 58.5977 40.103 58.5977C38.3442 58.5977 36.9952 60.0673 36.9952 61.7835C36.9952 63.4997 38.3442 64.9693 40.103 64.9693Z",
    stroke: "white",
    strokeWidth: 2.31818
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_369_3875",
    x: -0.818182,
    y: -0.00763512,
    width: 89.6364,
    height: 89.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.40909
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.568627 0 0 0 0 0.611765 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_369_3875"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_369_3875",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStHail);
export default __webpack_public_path__ + "static/media/st_hail.bee4c635c55e1953288cea07d32303f9.svg";
export { ForwardRef as ReactComponent };